import React from "react";
import "../../../styles/listGroup.css";

const ListGroup = ({ items }) => {
  if (!items) return null;

  return (
      <div className="list-group-container">
        <ul className="list-group list-group-horizontal boxList">
          <li className="list-group-item fw-bold">Vidurkis</li>

          <li className="list-group-item one-item">
            <span>Bazinis įmonės pasiruošimas</span>
            <strong>{Math.round(items['Bazinis įmonės pasiruošimas'])}</strong>
          </li>
          <li className="list-group-item two-item">
            <span>Tikslinių rinkų ir segmentų pažinimas</span>
            <strong>{Math.round(items['Tikslinių rinkų ir segmentų pažinimas'])}</strong>
          </li>
          <li className="list-group-item three-item">
            <span>Produktų / paslaugų paruošimas eksportui</span>
            <strong>{Math.round(items['Produktų / paslaugų paruošimas eksportui'])}</strong>
          </li>
          <li className="list-group-item four-item">
            <span>Rinkodara ir viešieji ryšiai</span>
            <strong>{Math.round(items['Rinkodara ir viešieji ryšiai'])}</strong>
          </li>
          <li className="list-group-item five-item">
            <span>Eksporto pardavimų proceso valdymas ir įgūdžiai</span>
            <strong>{Math.round(items['Eksporto pardavimų proceso valdymas ir įgūdžiai'])}</strong>
          </li>
          <li className="list-group-item six-item">
            <span>Pasiryžimas plėsti eksportą ir veiksmų planavimas</span>
            <strong>{Math.round(items['Pasiryžimas plėsti eksportą ir veiksmų planavimas'])}</strong>
          </li>
          <li className="list-group-item seven-item">
            <span>Eksporto kanalų diversifikavimas</span>
            <strong>{Math.round(items['Eksporto kanalų diversifikavimas'])}</strong>
          </li>
          <li className="list-group-item eight-item">
            <span>Eksporto dalis apyvartoje</span>
            <strong>{Math.round(items['Eksporto dalis apyvartoje'])}</strong>
          </li>
          <li className="list-group-item nine-item">
            <span>Eksporto istorija</span>
            <strong>{Math.round(items['Eksporto istorija'])}</strong>
          </li>
          <li className="list-group-item ten-item">
            <span>Eksporto geografija</span>
            <strong>{Math.round(items['Eksporto geografija'])}</strong>
          </li>
          <li className="list-group-item eleven-item">
            <span>Eksporto apimtys</span>
            <strong>{Math.round(items['Eksporto apimtys'])}</strong>
          </li>
        </ul>
      </div>
  );
};

export default ListGroup;
